
import React, { useState } from "react";

const SetupAccount = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobileNumber: "",
    eventType: "",
    description: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted", formData);
    // Add submission logic here
  };

  const inputClasses = "w-full bg-transparent border border-[#333333] rounded-lg px-4 py-3.5 text-white placeholder-gray-500 focus:border-[#17BD3B] focus:ring-1 focus:ring-[#17BD3B] outline-none transition-all duration-300 font-poppins text-sm";
  const labelClasses = "block text-[#B3B3B3] text-sm font-medium mb-2 font-poppins";

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-4 py-24 sm:py-32">
      <div className="w-full max-w-[800px]">

        <h1 className="text-white text-3xl sm:text-4xl font-semibold text-center mb-12 font-poppins">
          List Your Event
        </h1>

        <div className="bg-[#111111] rounded-2xl p-6 sm:p-10 border border-[#222222]">
          <form onSubmit={handleSubmit} className="space-y-6">

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {/* First Name */}
              <div>
                <label className={labelClasses}>First Name</label>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  placeholder="Enter First Name"
                  className={inputClasses}
                />
              </div>

              {/* Last Name */}
              <div>
                <label className={labelClasses}>Last Name<span className="text-red-500">*</span></label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  placeholder="Enter Last Name"
                  className={inputClasses}
                  required
                />
              </div>

              {/* Email */}
              <div>
                <label className={labelClasses}>Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your Email"
                  className={inputClasses}
                />
              </div>

              {/* Mobile Number */}
              <div>
                <label className={labelClasses}>Mobile Number<span className="text-red-500">*</span></label>
                <input
                  type="tel"
                  name="mobileNumber"
                  value={formData.mobileNumber}
                  onChange={handleChange}
                  placeholder="Enter your Mobile Number"
                  className={inputClasses}
                  required
                />
              </div>
            </div>

            {/* Event Type */}
            <div>
              <label className={labelClasses}>Event Type</label>
              <div className="relative">
                <select
                  name="eventType"
                  value={formData.eventType}
                  onChange={handleChange}
                  className={`${inputClasses} appearance-none cursor-pointer`}
                >
                  <option value="" className="bg-[#111111]">Select Event Type</option>
                  <option value="concert" className="bg-[#111111]">Concert</option>
                  <option value="workshop" className="bg-[#111111]">Workshop</option>
                  <option value="conference" className="bg-[#111111]">Conference</option>
                  <option value="meetup" className="bg-[#111111]">Meetup</option>
                </select>
                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                  <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1.5L6 6.5L11 1.5" stroke="#666666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
              </div>
            </div>

            {/* Description */}
            <div>
              <label className={labelClasses}>Description<span className="text-red-500">*</span></label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                placeholder="Enter your Description"
                rows="4"
                className={`${inputClasses} resize-none`}
                required
              />
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="w-full bg-[#17BD3B] hover:bg-[#15a834] text-white font-semibold text-base py-4 rounded-lg transition-all duration-300 shadow-lg shadow-[#17BD3B]/20 mt-4"
            >
              Submit
            </button>

          </form>
        </div>
      </div>
    </div>
  );
};

export default SetupAccount;
